import { useAuth0 } from "@auth0/auth0-react"
import React, { useCallback } from "react"
import { List } from "semantic-ui-react"
import { ReactComponent as DevicesIcon } from "../../../../../Icons/devices-icon.svg"
import { isSuperAdminOrAdmin } from "../../../../../Utils/util"
import BifrostList from "../../../../BifrostElementComponent/BifrostList/BifrostList"
import AddDeviceToGroupModal from "../GroupDetailModal/AddDeviceToGroupModal"
import RemoveFromGroupModal from "../GroupDetailModal/RemoveFromGroupModal"

const GroupStructDevices = ({ group, refreshData }) => {
	const { user } = useAuth0()

	const listHandler = useCallback(() => {
		const groupDevices = group.devices
		groupDevices.forEach((element) => {
			element.name = element.shortName
			element.listType = "devices"
			{
				isSuperAdminOrAdmin(user) ? (element.listHandler = <RemoveFromGroupModal item={element} group={group} refreshData={refreshData} />) : null
			}

			element.icon = (
				<List.Icon color="black">
					<DevicesIcon />
				</List.Icon>
			)
		})
		return groupDevices
	}, [group])

	const addDeviceToGroupmodal = () => {
		if (isSuperAdminOrAdmin(user)) {
			return <AddDeviceToGroupModal group={group} refreshData={refreshData} />
		}
	}

	return (
		<BifrostList
			list={{
				struct: "group",
				name: "Devices",
				path: "/devices/",
				icon: (
					<List.Icon>
						<DevicesIcon />
					</List.Icon>
				),
				description: group.devices.length,
				operationButton: addDeviceToGroupmodal(),
				content: listHandler(group.devices)
			}}
		/>
	)
}

GroupStructDevices.propTypes = {}

export default GroupStructDevices
